<template>
  <div class="contact-container">
    <header data-role="Header" class="home-navbar-container">
      <Navbar />
    </header>
    <div class="contact-content">
      <div class="contact-info">
        <h2>Locatie</h2>
        <p>
          Brandt Glaszettersbedrijf<br />
          Kerkebuurt 147<br />
          1647MD Berkhout
        </p>
        <h3>Contact Details</h3>
        <p>
          Email:
          <a href="mailto:202lang@gmail.com" class="email-link"
            >202lang@gmail.com</a
          >
        </p>
        <p>Telefoon: 06-53253974</p>
        <p>Afspraak maken op verzoek</p>
      </div>
      <div class="contact-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1439.6007824664682!2d4.9995762475168775!3d52.63992068947985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c8aa352b4f90ad%3A0x127d29d71c9b37ac!2sGlas%20in%20lood%20en%20erkent%20glaszetter%20meer%20dan%2030%20jaar%20ervaring%20*21!5e0!3m2!1snl!2snl!4v1732378522791!5m2!1snl!2snl"
          class="map-iframe"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
    <div class="contact-section-separator6"></div>
    <div class="contact-section-separator7"></div>
    <div class="contact-footer-container">
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from "../components/navbar.vue";
import Footer from "../components/footer.vue";

export default {
  name: "Contact",
  components: {
    Navbar,
    Footer,
  },
  metaInfo: {
    title: "Contact - Langglas",
    meta: [
      {
        property: "og:title",
        content: "Contact - Langglas",
      },
    ],
  },
};
</script>

<style scoped>
.email-link {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.email-link:hover {
  color: darkblue;
}
.contact-section-separator6 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.contact-section-separator7 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}

.contact-footer-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
}

.contact-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;
  height: 100.1vh;
  overflow: none;
}

.home-navbar-container {
  top: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  z-index: 100;
  position: absolute;
  box-shadow: 5px 5px 10px 0px #d4d4d4;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f5ff1c;
}
.home-navbar {
  width: 1550px;
  display: flex;
  max-width: auto;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
}

.contact-content {
  display: flex;
  flex: 1;
  padding: 20px;
  gap: 20px;
  margin-top: 60px;
}

.contact-info {
  max-width: 400px;
  padding: 20px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  align-self: flex-start;
}

.contact-map {
  flex-grow: 1;
  height: calc(90% - 20px);
  display: flex;
  margin-top: 80px;
}

.map-iframe {
  width: 90%;
  height: 100%;
}

@media (max-width: 768px) {
  .contact-content {
    flex-direction: column;
    margin-top: 80px;
  }

  .contact-map {
    height: 300px;
  }
}
</style>
